import { GraduationCap, BookOpen, CreditCard } from "lucide-react";

import DataFetcherTemplateHome from "../../hooks/DataFetcherTemplateHome";
import BlockImageCabecera from "../../components/BlockImageCabecera";
import Block3Columns from "../../components/Block3Columns";

const url =
  "https://be-ofertas.utpl.edu.ec/jsonapi/node/template_home/63e21e54-1471-4a50-bdee-f8cc6c5fed9c" +
  "?include=field_imagen_portada.field_media_image" +
  "&fields[node--template_home]=title,field_imagen_portada,field_texto_portada,field_bloque1,field_bloque2,field_bloque3" +
  "&fields[media--image]=field_media_image" +
  "&fields[file--file]=uri";

function SistemaAcademico() {
  const DataDisplay = ({ data }) => (
    <div>
      <BlockImageCabecera
        src={data.imagen_portada}
        title={
          <div
            dangerouslySetInnerHTML={{
              __html: data.texto_portada,
            }}
          />
        }
      />

      <div className="lightbluebg padding">
        <Block3Columns
          col1={
            <div className="bg-white rounded-2xl shadow-xl shadow-slate-200/50 p-6 flex flex-col items-center text-center gap-4">
              <div className="w-16 h-16 rounded-2xl flex items-center justify-center bg-blue-50 text-blue-600">
                <BookOpen className="w-8 h-8 block translate-y-[1px]" />
              </div>
              <center>
                <div
                  className="w-[90%]"
                  dangerouslySetInnerHTML={{
                    __html: data.bloque1,
                  }}
                />
              </center>
            </div>
          }
          col2={
            <div className="bg-white rounded-2xl shadow-xl shadow-slate-200/50 p-6 flex flex-col items-center text-center gap-4">
              <div className="w-16 h-16 rounded-2xl flex items-center justify-center bg-yellow-50 text-yellow-600">
                <GraduationCap className="w-8 h-8 block" />
              </div>

              <center>
                <div
                  className="w-[90%]"
                  dangerouslySetInnerHTML={{
                    __html: data.bloque2,
                  }}
                />
              </center>
            </div>
          }
          col3={
            <div className="bg-white rounded-2xl shadow-xl shadow-slate-200/50 p-6 flex flex-col items-center text-center gap-4">
              <div className="w-16 h-16 rounded-2xl flex items-center justify-center bg-blue-50 text-blue-600">
                <CreditCard className="w-8 h-8 block" />
              </div>

              <center>
                <div
                  className="w-[90%]"
                  dangerouslySetInnerHTML={{
                    __html: data.bloque3,
                  }}
                />
              </center>
            </div>
          }
        />
      </div>
    </div>
  );

  return (
    <DataFetcherTemplateHome url={url}>
      {(data) => <DataDisplay data={data} />}
    </DataFetcherTemplateHome>
  );
}

export default SistemaAcademico;
